"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.slidePrev = exports.slideNext = void 0;

var slideNext = function slideNext(carousel, speed) {
  carousel.current.classList.add("slide");
  carousel.current.style.transform = "translateX(-".concat(carousel.current.firstChild.clientWidth, "px)");
  setTimeout(function () {
    carousel.current.classList.remove("slide");
    carousel.current.style.transform = null;
    carousel.current.insertBefore(carousel.current.firstChild, carousel.current.lastChild.nextSibling);
  }, speed);
};

exports.slideNext = slideNext;

var slidePrev = function slidePrev(carousel, speed) {
  carousel.current.classList.remove("slide");
  carousel.current.style.transform = "translateX(-".concat(carousel.current.firstChild.clientWidth, "px)");
  carousel.current.insertBefore(carousel.current.lastChild, carousel.current.firstChild);
  setTimeout(function () {
    carousel.current.classList.add("slide");
    carousel.current.style.transform = null;
  }, 0);
};

exports.slidePrev = slidePrev;